<template>
  <div
    class="add_to_cart_message_div"
    @click="$emit('showAddToCartMsg', false)"
  >
    <div class="add_to_cart_message msg">
      <b>محصول اضافه شد</b>
      <p>
        محصول مورد نظر به سبدخرید اضافه شد. لطفا برای تکمبل فرایند خرید به
        سبدخرید خود مراجعه کنید.
      </p>
      <div class="button_div">
        <button
          class="go_to_cart_btn"
          @click="
            $emit('showAddToCartMsg', false);
            this.$router.push('/user-cart/list');
          "
        >
          <img src="@/assets/img/option-cards/cart.svg" alt="" />
          سبدخرید
        </button>
        <button
          class="cansel_msg_btn"
          @click="$emit('showAddToCartMsg', false)"
        >
          باشه بعداً
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "addToCartMessage",
  data() {
    return {};
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/addToCartMessage/addToCartMessage.css);
</style>
